import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { managedAccommodationsOptions, positionTypeOptions } from "../../../utils/options";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { FormBusiness } from "./form";

interface IModalReservationsProps {
  onCancel: Function;
  onSave: Function;
  defaultId?: string;
  openModal: boolean;
  backgroundVisible?: boolean;
}

const texts: any = {
  title: {
    new: "Cadastro de Empresa",
    edit: "Informações da Empresa",
  },
  subTitle: {
    new: "Informe os dados da empresa",
    edit: "Segue abaixo as informações da empresa",
  },
};

export const ModalBusiness: React.FC<IModalReservationsProps> = (props) => {
  const { onCancel, onSave, openModal, backgroundVisible, defaultId } = props;

  const { api } = useApi();
  const { theme, notify } = useGlobal();

  const [loading, setLoading] = useState(!!defaultId);
  const [defaultData, setDefaultData] = useState<any>({});

  const searchBusiness = useCallback(async () => {
    if (defaultId) {
      setLoading(true);
      try {
        const { data } = await api.get(`/business/${defaultId}`)

        const _data = {} as any;

        Object.assign(_data, {
          ...data,
          email_business: data?.email,
          phone_business: data?.phone,
          state_id: { label: data?.state?.name, value: data?.state?.id },
          city_id: { label: data?.cities?.name, value: data?.cities?.id },
          surname: data?.responsible?.surname,
          position: { label: positionTypeOptions.find((item) => item.value === data?.responsible?.position)?.label, value: data?.responsible?.position },
          managed_accommodations: { label: managedAccommodationsOptions.find((item) => item.value === data?.managed_accommodations)?.label, value: data?.managed_accommodations },
          phone: data?.responsible?.phone,
          email: data?.responsible?.email,
        });

        setDefaultData({ ..._data });
      } catch (err) {
        console.error(err);
        notify("Erro ao buscar a empresa", "error");
        onCancel();
      } finally {
        setLoading(false);
      }
    }
  }, [defaultId]);

  useEffect(() => {
    searchBusiness();
  }, []);

  return (
    <ModalGeneric
      backgroundVisible={backgroundVisible}
      open={openModal}
      onClose={() => { }}
    >
      <Container theme={theme}>
        <ModalHeader
          title={texts.title[defaultId ? "edit" : "new"]}
          subTitle={texts.subTitle[defaultId ? "edit" : "new"]}
          onCancel={() => onCancel()}
          theme={theme}
        />

        <div style={{ marginBottom: 20 }} />

        <ContentOrLoading type="wave" loading={loading} theme={theme}>
          {/*        {!loading && defaultData && defaultData?.id && (
            <Tabs defaultValue="form">
              <Tabs.List>
                <Tabs.Tab value="form" style={{ fontFamily: "14px", fontSize: "14px" }} icon={<FaRegBuilding size="18px" />}>Formulário</Tabs.Tab>
                <Tabs.Tab value="integrations" style={{ fontFamily: "14px", fontSize: "14px" }} icon={<AiFillApi size="18px" />}>Integrações</Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="form" pt="xs">
                <FormBusiness
                  onSave={onSave}
                  onCancel={onCancel}
                  defaultData={defaultData}
                />
              </Tabs.Panel>
              <Tabs.Panel value="integrations" pt="xs">
                <p></p>
                <IntegrationCards
                  integration_status={defaultData?.integration_status}
                />
              </Tabs.Panel>
            </Tabs>
          )} */}
        {/*   {!loading && defaultData && defaultData?.id && (
            <BoxIntregrationsCard>
              <Bag title="Integrações" description="Integrações conectadas da empresa" icon={<AiFillApi size={24} color={secondary[theme]} />}>
                <IntegrationCards
                  integration_status={defaultData?.integration_status}
                />
              </Bag>
            </BoxIntregrationsCard>
          )} */}

          <FormBusiness
            onSave={onSave}
            onCancel={onCancel}
            defaultData={defaultData}
          />
        </ContentOrLoading>
      </Container>
    </ModalGeneric>
  );
};
